import { Box, SvgIcon } from '@mui/material'
import React from 'react'
import { Col, Container, NavLink, Row } from 'react-bootstrap'
import iatalogo from "../../assets/images/IATA.png";
import "./footer.css"
import separator from '../../assets/images/icons/separator.svg'
import google_play_badge from '../../assets/images/icons/google_play_badge.svg'
import app_store from '../../assets/images/icons/app_store.svg'
import facebook from '../../assets/images/icons/facebook.svg'
import twitter from '../../assets/images/icons/twitter.svg'
import youtube from '../../assets/images/icons/youtube.svg'
import instagram from '../../assets/images/icons/instagram.svg'
import linkedin from '../../assets/images/icons/linkedin.svg'
import footer_logo from '../../assets/images/icons/footer-logo.svg'
import dropdown_arrow from '../../assets/images/icons/dropdown-arrow.svg'

function Footer() {
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("rotate-down");
        var panel = this.nextElementSibling;
        if (panel.style.display === "flex") {
          panel.style.display = "none";
        } else {
          panel.style.display = "flex";
        }
      });

    }
    return (
        <div className="footer" id="footer">
            <Container fluid>
            <footer id="site-footer" className="footer-desktop">
                <section className="horizontal-footer-section" id="footer-middle-section">
                    <div id="footer-about" className="footer-columns">
                        <h1>Flying with Akasa</h1>  
                    </div>
                    <div className="footer-columns">
                        <h1>Know Akasa</h1>
                    </div>
                    <div className="footer-columns">
                        <h1>Quick Links</h1>
                
                    </div>
                    <div className="footer-columns">
                        <h1>Media Centre</h1>
                    
                    </div>
                </section>

                <div className="relative">
                    <img src={separator} />
                </div>
                <img  class="accordion accordion-arrow rotate" src={dropdown_arrow} />
                <div className="horizontal-footer-section panel" id="footer-middle-section" >
                    <div className="footer-columns">

                    </div>

                    <div className="footer-columns">
                        
                    
                    </div>

                    <div className="footer-columns">
                        
                        
                    </div>

                    <div className="footer-columns">
                    

                    </div>

                </div>



                <section className="horizontal-footer-section" id="footer-middle-section">
                <div className="footer-middle-columns">
                <h1 className="download-styling">Download our app</h1>
                    <div>
                    <a href="#!"><img src={google_play_badge} /></a>
                    <a href="#!"><img src={app_store} /></a>
                    </div>
                </div>
                <div className="footer-middle-columns footer-middle-columns-end">
                    <div className='d-flex'>
                        <a href="#!"><img src={facebook} /></a>
                        <a href="#!"><img src={twitter} /></a>
                        <a href="#!"><img src={youtube} /></a>
                        <a href="#!"><img src={instagram} /></a>
                        <a href="#!"><img src={linkedin} /></a>
                    </div>
                </div>
                
                </section>


                <section className="horizontal-footer-section" id="footer-bottom-section">
                    <div className="footer-base-columns">
                        <div className="">
                            <a href="#!"><img src={footer_logo} /></a>
                        </div>
                    </div>

                    <div className="footer-base-columns">
                        <h1 className="copyRight-stying">© Copyright 2022 Akasa Air. All rights reserved</h1>                    
                    </div>

                    <div className="footer-base-columns">
                        <div className="footerTermscondition-layout">
                        <h1 className="tandc-styling"> Terms And Conditions</h1> 
                        <h1 className="tandc-styling"> Privacy Policy</h1>
                        </div>
                    </div>
                </section>

                </footer>


                <div className="accordion display-mobile">
                <div>
                <label for="section1" className="accordion__label">Flying with Akasa</label>
                <div className="accordion__content">
               
                            
                </div>
                </div>
                <div>
                <label for="section2" className="accordion__label">Know Akasa</label>
                <div className="accordion__content">
             
                </div>
                </div>
                <div>
                <label for="section3" className="accordion__label">Quick Links</label>
                <div className="accordion__content">
            
                </div>
                </div>

                <div>
                <label for="section4" className="accordion__label">Media Centre</label>
                <div className="accordion__content">
     
                </div>
                </div>

                <div>
                <label for="section5" className="accordion__label">Customer Support </label>
                <div className="accordion__content">
             
                </div>
                </div>


                <h2 className="footer-styling-downlaod">Download our app</h2>


                {/* <div className="mob-footer">
                    <div className="download-mob">
                    <a href="#!"><img src="./images/googlePlayMob.svg" /></a>
                    </div>
                    <div  className="download-mob">  
                    <a href="#!"><img src="./images/appStoreMob.svg" /></a>
                    </div>
                </div> */}


                <div>
                <div className='d-flex'>
                    <a href="#!"><img src={facebook} /></a>

                    <a href="#!"><img src={twitter} /></a>
                    <a href="#!"><img src={youtube} /></a>
                    <a href="#!"><img src={instagram} /></a>
                    <a href="#!"><img src={linkedin} /></a>
                </div>
                </div>

                </div>
            </Container>
        </div>
    )
}

export default Footer
